<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>SEA IMP Report Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">

          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <span class="error">Only 1 Month Data Filter Apply in Date Field</span>
          <b-row>
            <b-col md="4">
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                class="mt-2"
              >
              </date-range-picker>
            </b-col>
            <b-col md="4">
              <b-form-input :formatter="capitalizeAll"
                class="mt-2"
                v-model="assignmentFilter"
                placeholder=" Assignment No."
              ></b-form-input>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event,'All','finalAllPlaceDataPOR')"
                @searchchange="getLocationList($event,'All','finalAllPlaceDataPOR')"
                :list="finalAllPlaceDataPOR"
                v-model="PORfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Place of Receipt"
              >
              </model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event,'All','finalAllPlaceDataPOD')"
                @searchchange="getLocationList($event,'All','finalAllPlaceDataPOD')"
                :list="finalAllPlaceDataPOD"
                v-model="PODfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Port of Discharge"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event,'All','finalAllPlaceDataLP')"
                @searchchange="getLocationList($event,'All','finalAllPlaceDataLP')"
                :list="finalAllPlaceDataLP"
                v-model="LPfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Load Port"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="shippingList"
                v-model="shippingFilter"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
              class="mt-2"
              :list="SOBStatusList"
              v-model="SOBFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select SOB Status"
            ></model-list-select>
            </b-col>
            <b-col md="4">
              <b-form-input :formatter="capitalizeAll"
                class="mt-2"
                v-model="containerNoFilter"
                placeholder=" Container No."
              ></b-form-input>
            </b-col>
            <b-col md="4">
              <b-form-input :formatter="capitalizeAll"
                class="mt-2"
                v-model="BOE_NoFilter"
                placeholder="BOE No."
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" center>
              <b-button
                size="sm"
                class="mt-2"
                @click="filterSearch"
                variant="outline-primary"
                >Search</b-button
              >

              <b-button
                size="sm"
                class="mt-2 ml-3"
                @click="clearFilter"
                variant="outline-info"
                >clear</b-button
              >
              <!-- <b-button
                size="sm"
                class="mt-2 ml-3"
                @click="getReportsAss('SEA_IMP_DSR_MainAssignment_SCREEN')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button
                class="mt-2 ml-3"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="getReportsAss('SEA_IMP_DSR_MainAssignment_SCREEN')"
                size="sm"
                variant="outline-info"
                > {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="25"
              style="margin: 0px"
              align="right"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <md-icon>{{
                  row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <b>{{ row1.item.mainSalesSeries }}</b>
                <br />
                <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ? "Sea" : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                >
                <br />
                <span
                  >Assignment Dt. :
                  {{ row1.item.assignmentDate | moment }}</span
                >
                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> <br />
                <span v-if="row1.item.sob_date !='' && row1.item.sob_date !=null" ><b :style="'color:black'">SOB : {{ row1.item.sob_date }}</b> <b-badge variant="danger"><b>SAILED</b></b-badge></span>
                <br />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <br />
                <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row1.item.allModuleId" :jb_series="row1.item.mainSalesSeries" />
                
                <h7 class="mt-2" v-if="row1.item.splitFromId!='0'"><b-badge variant="info">Split of {{row1.item.splitFromNo}}</b-badge> </h7>
                 
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' &&
                    row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <!-- <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')"
                  >FF :-
                  {{
                    row2.item.ffInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')"
                  >CC :-
                  {{
                    row2.item.ccInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')"
                  >TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}</span
                >
              </template> -->
              
              <template slot="containerNo" slot-scope="row15">
                <div v-if="row15.item.containerNo">

                      <h6><b-badge variant="light"
                        >{{ row15.item.containerNo+" / "+row15.item.containerType }}
                      </b-badge></h6>
                  <!-- <span
                    v-for="(item1, index) in row15.item.containerNo.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6></span
                  > -->
                </div>
                <span v-else>-----------</span>
              </template>
               <template slot="TEUS" slot-scope="row151">
                 <h6 v-if="row151.item.TEUS_Type"><b-badge variant="light"
                        >{{ row151.item.TEUS_Type }}
                      </b-badge></h6>
               </template>
              <template slot="shipperInv" slot-scope="row150">
                <div v-if="row150.item.shipperInv">
                  <span
                    v-for="(item2, index) in row150.item.shipperInv.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="ShippingB" slot-scope="row100">
                <div v-if="row100.item.ShippingB">
                  BOE No:
                  <span
                    v-for="(item3, index) in row100.item.ShippingB.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                  BOE Date:
                  <span><h6>
                      <b-badge variant="light"
                        >{{ row100.item.BOE_Date }}
                      </b-badge>
                    </h6></span
                  >
                  
                </div>
                <span v-else>-----------</span>
              </template>
 <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.billingSeries">
                  <span
                    v-for="(item3, index) in row1000.item.billingSeries.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
                <Add-Message  :fk_all_module_id="row1000.item.allModuleId" style="list-style-type: none;"/>
              </template>
              

            </b-table>
          </div>
        </div>

        <div>
            <b-pagination
              limit="25"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
        </div>
      </b-card-text>
    </b-card>
        <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
 
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import {DateFormat, selectDateFormat} from "../../helper/filters"
import { globalPermissionStatus,GlobalGetLocation, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "./docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";

export default {
    beforeMount() {
      this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", "/mainReport");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export as Excel",
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason:"",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      
      // date: ['2018-06-01'],
      dateRange: {
        startDate: '',
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 50,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container No./Type",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        
        {
          key: "TEUS",
          mainkey: "TEUS",
          label: "TEUS",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "BOE",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        // {
        //   key: "ffInvoiceClosed",
        //   mainkey: "ffInvoiceClosed",
        //   label: "Execution Invoice",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "Z.",
        // },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        // {
        //   key: "mainEnquiryId",
        //   mainkey: "mainEnquiryId",
        //   label: "Billing",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],
      
      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      ContainerFilter: "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: "0",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      clientMaster: [],
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      shippingList: [],
      shippingFilter: "",
      PORfilter: "",
      PODfilter: "",
      LPfilter: "",
      reload: true,
      jobRecList: [
          { value: '0', text: 'TPT Received' },
          { value: '1', text: 'CC Received' },
          { value: '2', text: 'FF Received' },
         
        ],
  
      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
{
          inv: "3",
          int: "No-Billing",
        },
      ],
       SOBFilter:"3",
       containerNoFilter:'',
       BOE_NoFilter:'',
       SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
    AddMessage,
    AssignmentSummary,
  },

  computed: {},
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
     InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
  },
  methods: {
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    getCurrentLastDate(){
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, '0');
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, '0'); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, '0');
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, '0'); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy+ '/' +firstDay_mm + '/' + firstDay_dd;//2018-06-01
      lastDay = lastDay_yyyy+ '/' +lastDay_mm + '/' + lastDay_dd;//2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy+ '/' +mm + '/' + dd;//2018-06-01
      this.startDate = today;
      this.dateRange= {
        startDate: firstDay,
        endDate: lastDay,
      }
      // alert(today);
    },
getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
validateBilling(id,jobType){
 this.selectedAllModuleId = id;
this.isLoading=true
  
      let payload = {
        allModuleId: id,
        job: jobType,

      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if(data.incompleteJobBill.length>0){
this.incompleteJobBill=data.incompleteJobBill.toString();
}
  this.$refs['modal-close-conf'].show()
this.isLoading=false
          }
        })
        .catch((error) => {});
    

},

      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      getReportsAss(id) {
        let excelIdGivin = "";
        if (id == "SEA_IMP_DSR_MainAssignment_SCREEN") {
          excelIdGivin = "SEA_IMP_DSR_MainAssignment_SCREEN";
        }else if(id=="SEA_IMP_DSR_MainAssignment_SCREEN_ALL"){
          excelIdGivin = "SEA_IMP_DSR_MainAssignment_SCREEN_ALL";
        }
        let view_Assignment = {
          excelId: excelIdGivin,
          clientIdFilter: this.clientIdFilter,
          assignmentFilter: this.assignmentFilter,
          ContainerFilter: this.ContainerFilter,
          shiperInvFilter: '',
          InvoiceNoFilter: '',
          SBFilter: '',
          jobTypeFilter: this.jobTypeFilter,
          statusFilter:'',
          branchfilter: this.branchfilter,
          SOBFilter:this.SOBFilter,
          containerNoFilter:this.containerNoFilter,
          BOE_NoFilter : this.BOE_NoFilter,
          jobRecFilter: '',
          searchVal: this.filter,

          assignmentNo: "assignmentNo",
          fromDate: this.dateSearch.fromDate,
          toDate: this.dateSearch.toDate,
          dateRange: this.dateRange,
          shippingFilter:this.shippingFilter,
          PORfilter:this.PORfilter,
          PODfilter:this.PODfilter,
          LPfilter:this.LPfilter,
        };
        this.ExcelBtnName = "Downloading Please Wait ....."; 
        
        CommonService.getAllMainReport(view_Assignment)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.excelName) {
                this.ExcelBtnName = 'Export as Excel';
               
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
                 // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
                  
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on All_BL_List Error: ", error);
          });
      },
    // getReportsAss(id) {
    //   this.isLoading=true
    //   // alert(this.jobTypeFilter);
    //   // alert(id);
    //   let excelIdGivin = "";
    //   if (id == "SEA_IMP_DSR_MainAssignment_SCREEN") {
    //     excelIdGivin = "SEA_IMP_DSR_MainAssignment_SCREEN";
    //   }else if(id=="SEA_IMP_DSR_MainAssignment_SCREEN_ALL"){
    //     excelIdGivin = "SEA_IMP_DSR_MainAssignment_SCREEN_ALL";
    //   }
    //   let view_Assignment = {
    //     excelId: excelIdGivin,
    //     clientIdFilter: this.clientIdFilter,
    //     assignmentFilter: this.assignmentFilter,
    //     ContainerFilter: this.ContainerFilter,
    //     shiperInvFilter: '',
    //     InvoiceNoFilter: '',
    //     SBFilter: '',
    //     jobTypeFilter: this.jobTypeFilter,
    //     statusFilter:'',
    //     branchfilter: this.branchfilter,
    //     SOBFilter:this.SOBFilter,
    //     containerNoFilter:this.containerNoFilter,
    //     BOE_NoFilter : this.BOE_NoFilter,
    //     jobRecFilter: '',
    //     searchVal: this.filter,

    //     assignmentNo: "assignmentNo",
    //     fromDate: this.dateSearch.fromDate,
    //     toDate: this.dateSearch.toDate,
    //     dateRange: this.dateRange,
    //     shippingFilter:this.shippingFilter,
    //     PORfilter:this.PORfilter,
    //     PODfilter:this.PODfilter,
    //     LPfilter:this.LPfilter,
    //   };
    //   console.log(view_Assignment);
    //   let options = {
    //     method: "POST",
    //     // url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
    //     url: `${URL_BASE}/Api_MainReport/reportsMainExcel.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if ( status == 200 && data) {
    //         if (data.excelName != undefined) {
    //           window.location.href =
    //             `https://uploadsp.pridel.com/Pridel_Reports/` +
    //             data.excelName;
    //         }
    //         this.isLoading=false
    //       }
    //     })
    //     .catch((error) => {});
    // },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
       this.statusFilter = "";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.SBFilter = "";
      this.SOBFilter="3";
      this.containerNoFilter="",
      this.BOE_NoFilter="",
      this.dateRange={
      startDate: "",
              endDate: "",
      },
      this.shippingFilter = "";
      this.PORfilter = "";
      this.PODfilter = "";
      this.LPfilter = "";
      this.viewFFExportFCL("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      
      this.consoBooking = [];
      this.isLoading = true;
      let payload = {
        excelId:'',
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: '',
        branchfilter: this.branchfilter,
        jobRecFilter: '',
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        shippingFilter: this.shippingFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        SOBFilter:this.SOBFilter,
        containerNoFilter:this.containerNoFilter,
        BOE_NoFilter:this.BOE_NoFilter,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_MainReport/viewDSR_SEA_IMPReport.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log("Report Data=>",data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }

              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewDSRIMPReports.vue?b7d923e6